<template>
  <div class="home-page">
    <div class="home-bg"></div>
    <div class="home-mask"></div>

    <div class="header">
      <div class="header_content">
        <div
            class="header-left"
            v-if="!hasToken"
            @click="toLogin('/Register')"
        >
          {{ $t("auth.register") }}
        </div>

        <div class="header-left" v-else></div>

        <div class="logo-box">
          <img src="/img/homenavlogo.png?t=2" alt="" />
        </div>

        <div
            class="header-chat"
            v-if="!hasToken"
            @click="toLogin('/Login')"
        >
          <van-icon name="chat-o" color="#fff" size="24" />
        </div>

        <div
            class="header-chat"
            v-else
            @click="toLogin('/ServiceOnline')"
        >
          <van-icon name="chat-o" color="#fff" size="24" />
        </div>
      </div>
    </div>

    <!-- Banner -->
    <div class="banner-section">
      <swiper class="banner_swiper" :options="bannerSwiperOption">
        <swiper-slide
            v-for="(v, key) in banners"
            :key="key"
        >
          <van-image
              class="banner_img"
              :src="v.url"
              width="100%"
              height="100%"
          >
            <template v-slot:loading>
              <van-loading type="circular" />
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
    </div>

    <!-- 公告 -->
    <div class="notice-box">
      <van-icon
          name="volume-o"
          class="notice-icon"
      />

      <div class="notice-scroll">
        <div class="notice-text">
          {{ notice }}
        </div>
      </div>
    </div>

    <!-- 高端专区 -->
    <div class="section-title high-title">
      <span>
        {{ $t("index.Highend_area") }}
      </span>

      <em>
        {{ $t("index.extreme") }}
      </em>
    </div>

    <div class="high-scroll">

      <div
          class="gdgride"
          v-for="(group, index) in groupedData"
          :key="index"
      >

        <div
            class="high-card"
            v-for="item in group"
            :key="item.id"
            @click="toDetail(item.id)"
        >
          <img
              :src="item.img_url"
              class="high-img"
          />

          <span class="corner">
            <i>
              {{ $t("index.airborne") }}
            </i>
          </span>

          <div class="high-name">
            {{ item.xuanfei_name }}
          </div>
        </div>

      </div>

      <div
          class="more-card"
          @click="toLogin('/Choose')"
      >
        {{ $t("concubine.ckgdsj") }}
      </div>

    </div>

    <!-- 推荐 -->
    <div class="recommendWrap">

      <div class="section-title recommendTitle">
        <span>
          {{ $t("index.recommend") }}
        </span>
      </div>

      <div
          class="horizontalItem"
          v-for="item in datalist"
          :key="item.id"
          @click="toDetail(item.id)"
      >

        <div class="imgBox">

          <img
              :src="item.img_url"
              class="coverImg"
          />

          <span class="corner">
            <i>
              {{ $t("concubine.high_end") }}
            </i>
          </span>

        </div>

        <div class="itemRight">

          <div class="top">

            <div class="authItem">
              <img
                  src="/img/vip.png"
                  class="authIcon"
              />

              <span>
                {{ $t("index.authentication") }}
              </span>
            </div>

            <div class="authItem">
              <img
                  src="/img/vip.png"
                  class="authIcon"
              />

              <span>
                {{ $t("index.video_authentication") }}
              </span>
            </div>

            <div class="nameText">
              {{ item.xuanfei_name }}
            </div>

          </div>

          <!-- 标签 -->
          <div
              class="tags"
              v-if="item.flagArray && item.flagArray.length"
          >

            <van-tag
                v-for="(tag, index) in item.flagArray"
                :key="index"
                :type="tagTypes[index % tagTypes.length]"
            >
              {{ tag }}
            </van-tag>

          </div>

          <!-- 评分 -->
          <div class="priceRow">

            <span class="priceLabel">
              {{ $t("index.toll") }}：
            </span>

            <van-rate
                v-model="item.number"
                color="#f14b82"
                size="19px"
            />

          </div>

          <!-- 信息 -->
          <div class="infoRow">

            <span>
              {{ $t("index.height") }}:
              {{ item.hight }}cm
            </span>

            <span>
              {{ $t("index.bust") }}：
              {{ item.bust }}
            </span>

            <span>
              {{ $t("index.address") }}：
              {{ item.address || "-" }}
            </span>

            <span>
              {{ $t("index.National") }}：
              {{ $t("index.yes") }}
            </span>

          </div>

          <div class="yueta">
            {{ $t("index.about") }}
          </div>

        </div>

      </div>

    </div>

    <div class="bottom-space"></div>

  </div>
</template>

<script>
export default {

  data() {
    return {

      notice: this.$t("index.loading"),

      translateY: -18,

      containerHeight: 0,

      hasToken: false,

      basicData: [],

      datalist: [],

      originalDatalist: [],

      groupedData: [],

      originalGroupedData: [],

      banners: [{}],

      searchValue: "",

      bannerSwiperOption: {

        effect: "coverflow",

        grabCursor: true,

        centeredSlides: true,

        slidesPerView: "auto",

        speed: 800,

        autoplay: true,

        coverflowEffect: {

          rotate: 50,

          stretch: 10,

          depth: 100,

          modifier: 1,

          slideShadows: true

        }

      },

      tagTypes: [
        "primary",
        "success",
        "danger",
        "warning"
      ]

    };
  },

  methods: {

    /**
     * 获取基础配置
     */
    getBasicConfig() {

      console.log(
          "========================================"
      );

      console.log(
          "开始请求接口：sys_config"
      );

      console.log(
          "========================================"
      );

      this.$http({

        method: "get",

        url: "sys_config"

      }).then((res) => {

        console.log(
            "========== sys_config 接口完整返回 =========="
        );

        console.log(res);

        console.log(
            "========== sys_config res.data =========="
        );

        console.log(res.data);

        console.log(
            "=========================================="
        );

        this.basicData = res.data;

        console.log(
            "sys_config 保存到 basicData：",
            this.basicData
        );

        this.getNotice(this.basicData);

        this.getBanner(this.basicData);

      }).catch((err) => {

        console.error(
            "========== sys_config 接口错误 =========="
        );

        console.error(err);

        console.error(
            "=========================================="
        );

      });

    },


    /**
     * 获取热门彩票
     */
    getHotLottery() {

      console.log(
          "========================================"
      );

      console.log(
          "开始请求接口：lottery_hot"
      );

      console.log(
          "========================================"
      );

      this.$http({

        method: "get",

        url: "lottery_hot"

      }).then((res) => {

        console.log(
            "========== lottery_hot 接口完整返回 =========="
        );

        console.log(res);

        console.log(
            "========== lottery_hot res.data =========="
        );

        console.log(res.data);

        console.log(
            "=========================================="
        );

      }).catch((err) => {

        console.error(
            "========== lottery_hot 接口错误 =========="
        );

        console.error(err);

        console.error(
            "=========================================="
        );

      });

    },


    /**
     * 获取 Banner
     */
    getBanner(data) {

      console.log(
          "========== getBanner =========="
      );

      console.log(
          "传入数据：",
          data
      );

      if (data && data.banners) {

        this.banners = data.banners;

      } else {

        this.banners = [{}];

      }

      console.log(
          "最终 banners：",
          this.banners
      );

      console.log(
          "================================"
      );

    },


    /**
     * 登录 / 注册 / 客服
     */
    toLogin(str) {

      console.log(
          "页面跳转：",
          str
      );

      this.$router.push({
        path: str
      });

    },


    /**
     * 获取公告
     */
    getNotice(data) {

      console.log(
          "========== getNotice =========="
      );

      console.log(
          "公告数据：",
          data
      );

      if (data && data.notice) {

        this.notice = data.notice;

      } else {

        this.notice = this.$t("index.loading");

      }

      console.log(
          "最终 notice：",
          this.notice
      );

      console.log(
          "================================"
      );

    },


    /**
     * 公告动画
     */
    startAnimation() {

      const interval = setInterval(() => {

        this.translateY -= 18;

        if (
            this.translateY <=
            -this.containerHeight
        ) {

          this.translateY = 0;

        }

      }, 1000);

      this.$once(
          "hook:beforeDestroy",
          () => {

            clearInterval(interval);

          }
      );

    },


    /**
     * 查看详情
     */
    toDetail(id) {

      console.log(
          "点击详情，ID：",
          id
      );

      this.$router.push({

        path: "/detail",

        query: {
          id: id
        }

      });

    },


    /**
     * 检查 Token
     */
    checkToken() {

      const token =
          localStorage.getItem("token");

      console.log(
          "当前 token：",
          token
      );

      this.hasToken = !!token;

      console.log(
          "当前登录状态 hasToken：",
          this.hasToken
      );

    },


    /**
     * 每两个数据分一组
     */
    buildGroupedData(list) {

      console.log(
          "========== buildGroupedData =========="
      );

      console.log(
          "传入 list：",
          list
      );

      const chunkSize = 2;

      const result = list.reduce(
          (acc, item, index) => {

            if (
                index % chunkSize === 0
            ) {

              acc.push([]);

            }

            acc[
                Math.floor(
                    index / chunkSize
                )
                ].push(item);

            return acc;

          },
          []
      );

      console.log(
          "分组结果：",
          result
      );

      console.log(
          "======================================"
      );

      return result;

    },


    /**
     * 拆分标签
     */
    splitFlags(flagText) {

      console.log(
          "splitFlags 原始数据：",
          flagText
      );

      if (!flagText) {

        return [];

      }

      const result = flagText
          .split(/[，,]/)
          .map((s) => {

            return (s || "").trim();

          })
          .filter(Boolean);

      console.log(
          "splitFlags 处理结果：",
          result
      );

      return result;

    },


    /**
     * 搜索
     */
    handleSearch() {

      console.log(
          "========== handleSearch =========="
      );

      const keyword =
          (this.searchValue || "")
              .toLowerCase();

      console.log(
          "搜索关键词：",
          keyword
      );

      if (!keyword) {

        this.datalist =
            JSON.parse(
                JSON.stringify(
                    this.originalDatalist
                )
            );

        this.groupedData =
            JSON.parse(
                JSON.stringify(
                    this.originalGroupedData
                )
            );

        console.log(
            "搜索为空，恢复全部数据"
        );

        return;

      }

      const filtered =
          this.originalDatalist.filter(
              (item) => {

                const name =
                    (
                        item.xuanfei_name ||
                        ""
                    ).toLowerCase();

                return (
                    name.indexOf(keyword) !== -1
                );

              }
          );

      this.datalist = filtered;

      this.groupedData =
          this.buildGroupedData(
              filtered
          );

      console.log(
          "搜索结果：",
          this.datalist
      );

      console.log(
          "================================"
      );

    },


    /**
     * 获取选妃列表
     */
    getxuanfeilist() {

      console.log("");
      console.log(
          "################################################"
      );

      console.log(
          "开始请求接口：xuanfeilist"
      );

      console.log(
          "请求参数：",
          {
            id: 1,
            page: 1
          }
      );

      console.log(
          "################################################"
      );

      this.$http({

        method: "get",

        url: "xuanfeilist",

        data: {
          page: 1
        }

      }).then((res) => {

        /**
         * 第一层：完整 Axios 返回
         */
        console.log("");
        console.log(
            "================================================"
        );

        console.log(
            "【xuanfeilist】接口完整返回："
        );

        console.log(res);

        /**
         * 第二层：data
         */
        console.log(
            "------------------------------------------------"
        );

        console.log(
            "【xuanfeilist】res.data："
        );

        console.log(res.data);

        /**
         * 数据类型
         */
        console.log(
            "------------------------------------------------"
        );

        console.log(
            "res.data 类型：",
            typeof res.data
        );

        console.log(
            "是否数组：",
            Array.isArray(res.data)
        );

        /**
         * 数据数量
         */
        if (Array.isArray(res.data)) {

          console.log(
              "返回数据数量：",
              res.data.length
          );

          console.log(
              "------------------------------------------------"
          );

          /**
           * 逐条打印
           */
          res.data.forEach(
              (item, index) => {

                console.log(
                    "【xuanfeilist 第 " +
                    index +
                    " 条】",
                    item
                );

              }
          );

        }

        console.log(
            "================================================"
        );

        /**
         * 当前语言
         */
        const lanng =
            localStorage.getItem("lang");

        console.log(
            "当前 localStorage.lang：",
            lanng
        );

        /**
         * 保存原始数据
         */
        this.datalist =
            res.data || [];

        console.log(
            "初始 datalist：",
            this.datalist
        );

        if (
            this.datalist &&
            this.datalist.length > 0
        ) {

          this.datalist.forEach(
              (item, index) => {

                console.log("");
                console.log(
                    "----------------------------------------"
                );

                console.log(
                    "开始处理第 " +
                    index +
                    " 条数据"
                );

                console.log(
                    "处理前 item：",
                    item
                );

                /**
                 * flag 多语言处理
                 */
                if (item.flag) {

                  console.log(
                      "原始 flag：",
                      item.flag
                  );

                  const parts =
                      item.flag.split("|");

                  console.log(
                      "flag 分割结果：",
                      parts
                  );

                  if (lanng == "zh") {

                    item.flag =
                        parts[0] || "";

                  } else if (
                      lanng == "en"
                  ) {

                    item.flag =
                        parts[1] ||
                        parts[0] ||
                        "";

                  } else if (
                      lanng == "ja" ||
                      lanng == "jp"
                  ) {

                    item.flag =
                        parts[2] ||
                        parts[0] ||
                        "";

                  } else {

                    item.flag =
                        parts[3] ||
                        parts[1] ||
                        parts[0] ||
                        "";

                  }

                  console.log(
                      "语言处理后的 flag：",
                      item.flag
                  );

                  item.flagArray =
                      this.splitFlags(
                          item.flag
                      );

                  console.log(
                      "最终 flagArray：",
                      item.flagArray
                  );

                } else {

                  item.flagArray = [];

                  console.log(
                      "没有 flag，flagArray 设置为空数组"
                  );

                }

                /**
                 * 默认评分
                 */
                if (!item.number) {

                  item.number = 5;

                  console.log(
                      "number 为空，设置默认评分：5"
                  );

                }

                console.log(
                    "处理后 item：",
                    item
                );

                console.log(
                    "----------------------------------------"
                );

              }
          );

          /**
           * 分组
           */
          this.groupedData =
              this.buildGroupedData(
                  this.datalist
              );

          /**
           * 保存原始数据
           */
          this.originalDatalist =
              JSON.parse(
                  JSON.stringify(
                      this.datalist
                  )
              );

          this.originalGroupedData =
              JSON.parse(
                  JSON.stringify(
                      this.groupedData
                  )
              );

          /**
           * 最终结果打印
           */
          console.log("");
          console.log(
              "################################################"
          );

          console.log(
              "【最终 datalist】"
          );

          console.log(
              this.datalist
          );

          console.log(
              "【最终 groupedData】"
          );

          console.log(
              this.groupedData
          );

          console.log(
              "【最终 originalDatalist】"
          );

          console.log(
              this.originalDatalist
          );

          console.log(
              "【最终 originalGroupedData】"
          );

          console.log(
              this.originalGroupedData
          );

          console.log(
              "################################################"
          );

        } else {

          console.warn(
              "xuanfeilist 返回数据为空"
          );

          this.groupedData = [];

          this.originalDatalist = [];

          this.originalGroupedData = [];

        }

      }).catch((err) => {

        console.log("");

        console.log(
            "################################################"
        );

        console.error(
            "【xuanfeilist】接口请求失败"
        );

        console.error(
            "错误对象：",
            err
        );

        if (err.response) {

          console.error(
              "HTTP 状态码：",
              err.response.status
          );

          console.error(
              "错误响应 data：",
              err.response.data
          );

          console.error(
              "错误响应 headers：",
              err.response.headers
          );

        }

        console.log(
            "################################################"
        );

      });

    }

  },


  mounted() {

    this.$nextTick(() => {

      if (
          this.$refs.scrollContainer
      ) {

        this.containerHeight =
            this.$refs
                .scrollContainer
                .clientHeight;

        this.startAnimation();

      }

    });

  },


  created() {

    console.log("");
    console.log(
        "================================================"
    );

    console.log(
        "首页 Home 开始初始化"
    );

    console.log(
        "当前 URL：",
        window.location.href
    );

    console.log(
        "当前语言：",
        localStorage.getItem("lang")
    );

    console.log(
        "当前 Token：",
        localStorage.getItem("token")
    );

    console.log(
        "================================================"
    );

    this.checkToken();

    this.getBasicConfig();

    this.getxuanfeilist();

    this.getHotLottery();

  }

};
</script>

<style lang="less" scoped>

.home-page {
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  color: #fff;
  background: #2f2035;
}

.home-bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  background: url("https://xhtd888.oss-cn-hongkong.aliyuncs.com/uu8/sts/hk_login.png")
  center top / cover no-repeat;
}

.home-mask {
  position: fixed;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(
      180deg,
      rgba(20, 18, 22, 0.72) 0%,
      rgba(52, 33, 58, 0.74) 26%,
      rgba(94, 62, 102, 0.90) 100%
  );
}

.header,
.banner-section,
.notice-box,
.section-title,
.high-scroll,
.recommendWrap,
.bottom-space {
  position: relative;
  z-index: 2;
}

.header {
  height: 108px;
  background: #201e22;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
}

.header_content {
  height: 88px;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  width: 54px;
  color: transparent;
  font-size: 0;
}

.logo-box {
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-box img {
  height: 58px;
  width: auto;
  object-fit: contain;
}

.header-chat {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.13);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

.banner-section {
  padding: 20px 28px 8px;
}

.banner_swiper {
  height: 210px !important;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 12px 34px rgba(20, 10, 28, 0.32);
}

.banner_img,
::v-deep .banner_img .van-image__img {
  width: 100%;
  height: 210px !important;
  object-fit: cover;
  border-radius: 14px;
}

.notice-box {
  height: 56px;
  margin: 8px 28px 22px;
  padding: 0 18px;
  border-radius: 28px;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.13);
  border: 1px solid rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 10px 26px rgba(30, 12, 36, 0.22);
}

.notice-icon {
  flex: 0 0 auto;
  margin-right: 12px;
  font-size: 25px;
  color: #ef477f;
}

.notice-scroll {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}

.notice-text {
  display: inline-block;
  padding-left: 100%;
  color: #fff;
  font-size: 24px;
  font-weight: 500;
  white-space: nowrap;
  animation: noticeMarquee 12s linear infinite;
}

@keyframes noticeMarquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}

.section-title {
  padding: 15px 28px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.section-title span {
  position: relative;
  padding-left: 26px;
  color: #fff;
  font-size: 28px;
  font-weight: 900;
  line-height: 1;
}

.section-title span::before {
  content: "";
  position: absolute;
  left: 0;
  top: 1px;
  width: 6px;
  height: 28px;
  border-radius: 8px;
  background: #ef477f;
}

.section-title em {
  margin-left: 12px;
  padding: 7px 14px;
  border-radius: 14px 0 14px 0;
  background: rgba(238, 74, 128, 0.26);
  color: #ffd5e2;
  font-size: 21px;
  font-style: normal;
  font-weight: 700;
}

.high-scroll {
  display: flex;
  overflow-x: auto;
  flex-wrap: nowrap;
  padding: 0 0 26px 28px;
  -webkit-overflow-scrolling: touch;
}

.high-scroll::-webkit-scrollbar {
  display: none;
}

.gdgride {
  flex: 0 0 auto;
  margin-right: 14px;
}

.high-card {
  position: relative;
  width: 226px;
  height: 226px;
  margin-bottom: 14px;
  overflow: hidden;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.12);
  box-shadow: 0 10px 22px rgba(15, 8, 20, 0.34);
}

.high-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.high-card::after,
.imgBox::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 46%;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.62)
  );
}

.corner {
  position: absolute;
  z-index: 3;
  right: -42px;
  top: -42px;
  width: 90px;
  height: 90px;
  transform: rotate(45deg);
  background: #ef477f;
  color: #fff;
}

.corner i {
  position: absolute;
  left: 50%;
  bottom: 7px;
  transform: translateX(-50%);
  font-size: 14px;
  font-weight: 900;
  font-style: normal;
  white-space: nowrap;
}

.high-name {
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
  bottom: 10px;
  text-align: center;
  color: #fff;
  font-size: 28px;
  font-weight: 600;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
}

.more-card {
  flex: 0 0 36px;
  height: 126px;
  margin-top: 62px;
  margin-right: 28px;
  padding: 16px 8px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.16);
  color: rgba(255, 255, 255, 0.75);
  font-size: 13px;
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;
  writing-mode: vertical-rl;
}

.recommendWrap {
  padding: 0 28px 90px;
}

.recommendTitle {
  padding: 0;
  margin: 6px 0 18px;
}

.horizontalItem {
  display: flex;
  align-items: flex-start;
  padding: 18px;
  margin-bottom: 20px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.13);
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  box-shadow: 0 16px 36px rgba(20, 10, 28, 0.34);
}

.imgBox {
  position: relative;
  flex: 0 0 154px;
  width: 154px;
  height: 154px;
  margin-right: 18px;
  border-radius: 12px;
  overflow: hidden;
}

.coverImg {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.itemRight {
  flex: 1;
  min-width: 0;
}

.top {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.authItem {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 10px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.18);
  color: rgba(255, 255, 255, 0.92);
  font-size: 19px;
  font-weight: 800;
}

.authIcon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  object-fit: contain;
}

.nameText {
  color: #fff;
  font-size: 25px;
  font-weight: 900;
  line-height: 1.2;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  margin: 8px 0 10px;
}

::v-deep .tags .van-tag {
  margin: 0 8px 7px 0;
  padding: 5px 12px;
  border-radius: 14px;
  font-size: 18px;
  line-height: 18px;
  border: none;
}

.priceRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.priceLabel,
.infoRow {
  color: rgba(255, 255, 255, 0.74);
  font-size: 26px;
  font-weight: 500;
}

.infoRow {
  margin: 8px 0 14px;
  line-height: 1.65;
  display: flex;
  flex-wrap: wrap;
  gap: 0 10px;
}

.yueta {
  height: 56px;
  line-height: 56px;
  border-radius: 10px;
  text-align: center;
  color: #fff;
  font-size: 22px;
  font-weight: 900;
  background: linear-gradient(
      90deg,
      #f36b68 0%,
      #e43e83 100%
  );
  box-shadow: 0 12px 26px rgba(226, 63, 130, 0.36);
}

.bottom-space {
  height: 60px;
}

@media screen and (max-width: 375px) {

  .header,
  .header_content {
    height: 78px;
  }

  .header_content {
    padding: 0 22px;
  }

  .logo-box,
  .logo-box img {
    height: 50px;
  }

  .banner-section {
    padding: 16px 22px 6px;
  }

  .banner_swiper,
  .banner_img,
  ::v-deep .banner_img .van-image__img {
    height: 185px !important;
  }

  .notice-box {
    margin: 8px 22px 20px;
    height: 82px;
  }

  .section-title,
  .high-scroll,
  .recommendWrap {
    padding-left: 22px;
    padding-right: 22px;
  }

  .high-scroll {
    padding-right: 0;
  }

  .high-card {
    width: 112px;
    height: 112px;
  }

  .imgBox {
    flex-basis: 120px;
    width: 120px;
    height: 120px;
    margin-right: 12px;
  }

  .nameText {
    font-size: 20px;
  }

  .yueta {
    height: 48px;
    line-height: 48px;
    font-size: 18px;
  }

}

</style>